import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";
import ResultTable from "../../../components/table/ResultTable";
import EmptyLine from "../EmptyLine";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import SuperText from "../SuperText";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function C11({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const renderTWSEL = ({text, row, max, min, globalVariables, hideNote, showList}) => {
    const start_cs = row?.start_cs
    const end_cs = row?.end_cs

    const getCSName = (cs_name, start, end) => {
        if(hideNote)
            return cs_name

        if(cs_name === start || cs_name === end)
            return (<>{cs_name}<SuperText text={'1'} /></>)

        return cs_name
    }

    return (
        <>
            <ResultText>
                {text}
                <EmptyLine />
            </ResultText>
            <ResultTable data={showList ? row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section})) : []}>
                <ResultHeader>
                    <ResultRow>
                        <ResultHeaderCell rowSpan={2} style={{verticalAlign: 'bottom', textAlign: 'left', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'center'}} colSpan={3}>100yr WSEL (ft)</ResultHeaderCell>
                    </ResultRow>
                    <ResultRow>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                        <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(15)}}>Difference</ResultHeaderCell>
                    </ResultRow>
                </ResultHeader>
                <ResultBody>
                    {
                        (row.data).map(r => {
                            return (
                                <ResultRow>
                                    <ResultBodyCell>
                                        <ComparisonCSName csName={getCSName(r.cross_section, start_cs, end_cs)} csNameVal={r.cross_section} />
                                    </ResultBodyCell>
                                    {
                                        !r.diff && (
                                            <ResultBodyCell colSpan={3}>
                                                {r.type} ({r.desc})
                                            </ResultBodyCell>
                                        )
                                    }
                                    {
                                        r.diff && (
                                            <>
                                                <ResultBodyCell style={{textAlign: 'right'}}>{r.selected_ws_elev}</ResultBodyCell>
                                                <ResultBodyCell style={{textAlign: 'right'}}>{r.target_ws_elev}</ResultBodyCell>
                                                <ResultBodyCell style={{textAlign: 'right'}}>
                                                    {
                                                        ((parseFloat(r.diff) === min || parseFloat(r.diff) === max) && (ResultCellHighlight(null, r.diff))) || r.diff
                                                    }
                                                </ResultBodyCell>
                                            </>
                                        )
                                    }
                                </ResultRow>
                            )
                        })
                    }
                </ResultBody>
            </ResultTable>
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.TWSEL000.error_id: {
            const temp = row.data.filter(x => !x.cross_section.includes('BR U') &&  !x.cross_section.includes('BR D')).map(x => parseFloat(x.diff))
            const max = Math.max(...(temp.filter(x => x > 0)))
            const min = Math.min(...(temp.filter(x => x < 0)))

            return (
                <>
                    {
                        renderTWSEL({
                            row,
                            globalVariables,
                            min,
                            max,
                            text: `The 100yr WSEL comparison table between ${globalVariables?.sel_plan_title || 'base'} and ${globalVariables?.tar_plan_title || 'comparison'} plans is listed below.`,
                            hideNote: true,
                            showList: false
                        })
                    }
                </>
            )
            return
        }
        case MessageCodes.Compare.WSEL001.error_id: {
            const temp = row.data.filter(x => !x.cross_section.includes('BR U') &&  !x.cross_section.includes('BR D')).map(x => parseFloat(x.diff))
            const max = Math.max(...(temp.filter(x => x >= 0)))
            const min = Math.min(...(temp.filter(x => x < 0)))

            return (
                <>
                    {
                        renderTWSEL({
                            row,
                            globalVariables,
                            max,
                            min,
                            showList: true,
                            text: `There are differences in the 100yr WSEL between ${globalVariables?.sel_plan_title || 'base'} and ${globalVariables?.tar_plan_title || 'comparison'} plans at the following ${row?.cs_count} cross sections. The maximum increase is ${max} ft and the maximum decrease is ${min} ft. The tie-in stations are also listed with zero difference.`
                        })
                    }

                    <ResultText>
                        <SuperText color={''} text={'1'} /> US/DS limit of the model.
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Compare.WSEL00.error_id: {
            return (
                <>
                    {
                        row?.data?.map(x => {
                            return (
                                <ResultText>
                                    There is no {x?.profile} profile in {x?.plan} plan, therefore {x?.profile} WSEL are not compared.
                                </ResultText>
                            )
                        })
                    }
                </>
            )
        }
    }
}